
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/resource-center/reviewer/[slug]",
      function () {
        return require("private-next-pages/resource-center/reviewer/[slug]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/resource-center/reviewer/[slug]"])
      });
    }
  